import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    activeIndex: localStorage.getItem('activeIndex') || 'index',
    token: sessionStorage.getItem('TOKEN') || ''
  },
  mutations: {
    SET_ACTIVE_INDEX (state, data) {
      state.activeIndex = data
      localStorage.setItem('activeIndex', state.activeIndex)
    },
    SET_TOKEN (state, data) {
      state.token = data
      sessionStorage.setItem('TOKEN', state.token)
    }
  },
  actions: {
    SetActiveIndex ({ commit }, data) {
      commit('SET_ACTIVE_INDEX', data)
    },
    SetToken ({ commit }, data) {
      commit('SET_TOKEN', data)
    }
  },
  modules: {
  }
})
